// extracted by mini-css-extract-plugin
export default {"title":"delete_title__nXQco","buttonPart":"delete_buttonPart__9PNGL","buttonCancel":"delete_buttonCancel__pU1F4","buttonDelete":"delete_buttonDelete__vumaq"};